import React from "react";

const HorizontalLine = () => {
  return <hr className="cross-sell-horizontal-line" />;
};

export { HorizontalLine };
